// Build-time feature flags. Mutable so unit tests can flip them.
const env = import.meta.env as Record<string, string | undefined>;

export const flags = {
  /**
   * The female body (F22). On unless the build sets `VITE_FEMALE_BODY=0`, a kill switch: with it off there is no
   * Female switch, `b=f` links open the male body, and female-only parts are left out of search.
   */
  femaleBody: env.VITE_FEMALE_BODY !== '0',
};
